import React, { useState, useEffect } from "react";
import { technologies } from "../utiles/constant";
import { categories } from "../utiles/constant";
const TechStack = () => {
  const [activeCategory, setActiveCategory] = useState("Frontend");
  useEffect(() => {
    const categoryContainer = document.querySelector('.categories-container');
    if (categoryContainer) {
      categoryContainer.scrollLeft = 0;
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveCategory((prevCategory) => {
        const currentIndex = categories.indexOf(prevCategory);
        const nextIndex = (currentIndex + 1) % categories.length;
        return categories[nextIndex];
      });
    }, 15000);

    return () => clearInterval(interval);
  }, []);
  const filteredTechnologies =
    activeCategory === "All"
      ? technologies
      : technologies.filter((tech) => tech.category === activeCategory);

  return (
    <div className="w-full mt-8">
      <h1 className="text-2xl text-center mb-2">My</h1>
      <h2 className="text-3xl font-bold text-center mb-8">Tech Stack</h2>

      {/* Horizontal scroll for buttons */}
      <div className="categories-container flex overflow-x-auto whitespace-nowrap scrollbar-hide mb-12 justify-between md:px-10 lg:px-12">
        {categories.map((category, index) => (
          <button
            key={index}
            className={`text-sm px-3 py-1 relative mb-2 transition-transform duration-300 ${activeCategory === category
                ? "text-primary font-semibold"
                : "text-gray-600"
              }`}
            onClick={() => setActiveCategory(category)}
          >
            {category}
            {activeCategory === category && (
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-primary"></span>
            )}
          </button>
        ))}
      </div>

      {/* Grid for technologies */}
      <div className="flex justify-center lg:h-40">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-20 lg:gap-x-16 md:gap-x-16 xl:gap-x-28">
          {filteredTechnologies.map((tech, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-evenly"
            >
              <img
                src={tech.image}
                alt={tech.name}
                className="w-28 h-28 object-contain mb-2 images transform transition-transform duration-500 hover:scale-125"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechStack;
